import { v4 } from "uuid";

if (window.crypto.randomUUID == null) {
  window.crypto.randomUUID = v4;
}

export {};
